export const CatalogPostcodeActions = {
  SHOW: 'SHOW',
  HIDE: 'HIDE',
  SHOW_ERROR: 'SHOW_ERROR',
  HIDE_ERROR: 'HIDE_ERROR',
};
